import { render, staticRenderFns } from "./SubmissionsThanks.vue?vue&type=template&id=1f3892a9&"
import script from "./SubmissionsThanks.vue?vue&type=script&lang=js&"
export * from "./SubmissionsThanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports